<template>
  <div class="d-flex pt-4 align-items-baseline checkboxes">
    <div v-for="choice in choices" :key="choice.value">
      <checkbox
        :id="`${attribute}-${choice.value}`"
        :label="choice.text"
        :name="attribute + '[]'"
        :value="isChecked(choice.value)"
        @update:data="(checked) => updateData(choice.value, checked)"
      >
      </checkbox>
    </div>
  </div>
</template>

<script>
import Checkbox from '@kanrisha/components/Elements/Form/Checkbox';
import { ref } from 'vue';

export default {
  components: {
    Checkbox,
  },
  props: {
    name: { type: String, default: '' },
    value: { type: Array, default: () => [] },
    attribute: { type: String, default: '' },
    choices: { type: Object, default: () => {} },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localValues = ref(props.value ?? []);

    const isChecked = (choice) => {
      return localValues.value?.includes(choice);
    };

    const updateData = (choice, checked) => {
      if (checked && !localValues.value.includes(choice)) {
        localValues.value.push(choice);
      } else if (!checked && localValues.value.includes(choice)) {
        localValues.value = localValues.value.filter((value) => value !== choice);
      }

      emit('update:data', localValues.value);
    };

    return {
      isChecked,
      localValues,
      updateData,
    };
  },
};
</script>
